import { render, staticRenderFns } from "./tiscFlag.vue?vue&type=template&id=86f7fb70&scoped=true&"
import script from "./tiscFlag.vue?vue&type=script&lang=js&"
export * from "./tiscFlag.vue?vue&type=script&lang=js&"
import style0 from "./tiscFlag.vue?vue&type=style&index=0&id=86f7fb70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f7fb70",
  null
  
)

export default component.exports